import { useState } from 'react';
import removeSvg from 'assets/icons/remove.svg';
import IconButton from 'lib/IconButton';
import Modal from 'lib/Modal';
import Button from 'lib/Button';
import { Theme } from 'lib/IconButton/IconButton.types';

type DeleteRendererProps = {
  data: {
    marketTagId: string;
  };
  onDeleteFrameTag: (tagId: string) => void;
};

const DeleteRenderer: React.FC<DeleteRendererProps> = ({ data, onDeleteFrameTag }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const toggleDeleteModal = (): void => {
    setShowDeleteModal((prevState) => !prevState);
  };

  const onDelete = (): void => {
    if (data.marketTagId) {
      onDeleteFrameTag(data.marketTagId);
    }
  };

  return (
    <>
      <IconButton
        icon={removeSvg}
        name="Delete tag"
        theme={Theme.SECONDARY}
        isDisabled={!data.marketTagId}
        handleOnClick={toggleDeleteModal}
      />
      <Modal
        isOpen={showDeleteModal}
        icon={removeSvg}
        iconStyles="text-pinkRed-500"
        title="Remove Tag?"
        actionButtons={
          <>
            <Button onClick={toggleDeleteModal}>Cancel</Button>
            <Button onClick={onDelete}>Remove</Button>
          </>
        }
      >
        <p className="ml-8 body-base text-neutral-950-opacity-60">
          Are you sure you want to remove this frame tag? This may affect the frame availability for your creative.
        </p>
      </Modal>
    </>
  );
};

export default DeleteRenderer;
